import { createPrefixedConstants } from 'app/common/CommonUtils';

export default createPrefixedConstants(
  'explore',
  `
    CLOSE_ALL_CARD_EXTRA_MENUS

    LOAD_BLOG_POSTS
    LOAD_BLOG_POSTS_DONE

    LOAD_POPULAR_ZAPS
    LOAD_POPULAR_ZAPS_DONE

    LOAD_POPULAR_ZAP_IDS
    LOAD_POPULAR_ZAP_IDS_DONE

    RESET_NUMBER_ZAPS_TO_SHOW

    SHOW_MORE_SHARED_ZAPS

    TOGGLE_LOADING_CARD

    TOGGLE_SERVICE_CARD_EXTRAS_MENU

    UPDATE_SERVICE_SEARCH_QUERY

    UPDATE_SERVICE_SORTING_RULE

  `
);
